import { render, staticRenderFns } from "./PosterLayout.vue?vue&type=template&id=512da748"
import script from "./PosterLayout.vue?vue&type=script&lang=js"
export * from "./PosterLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports